import React from "react";
import { TagManager } from "../model/TagManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { AppStateReadableSerializer } from "../model/AppStateReadableSerializer";
import { ClipboardHelper } from "../model/ClipboardHelper";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import LogoBar from "./LogoBar";

type ConfigActionsPageProps = {
	tagManager: TagManager;
};

const ConfigActionsPage: React.FunctionComponent<ConfigActionsPageProps> = (
	props: ConfigActionsPageProps
) => {
	const exportToClipboardModalId = "exportToClipboardModal";
	const resetConfigConfirmModalId = "resetConfigConfirmModal";
	const resetConfigModalId = "resetConfigModal";

	let state = props.tagManager.readState();

	let setModalVisibility = (modalId: string, visibility: boolean) => {
		const modalElement = document?.getElementById(modalId);
		if (modalElement) {
			modalElement.style.display = visibility ? "block" : "none";
		}
	};

	let exportToClipboard = () => {
		const tagsText =
			AppStateReadableSerializer.stateToReadable(state, false) ?? "";
		ClipboardHelper.copyToClipboard(tagsText);
		setModalVisibility(exportToClipboardModalId, true);
	};

	let resetConfigConfirmation = () => {
		setModalVisibility(resetConfigConfirmModalId, true);
	};

	let resetConfig = () => {
		setModalVisibility(resetConfigConfirmModalId, false);

		props.tagManager.resetState();

		setModalVisibility(resetConfigModalId, true);
	};

	return (
		<div className="ConfigActionsPage noselect">
			<LogoBar />
			<div className="Page-navbar w3-bar w3-top noselect">
				<Link to="/config" className="w3-bar-item w3-button w3-left">
					<FontAwesomeIcon
						icon={faArrowLeft}
						className="Page-navbar-icon"
					/>
				</Link>
			</div>

			<div className="Page-content w3-container w3-center">
				<h1>More Actions</h1>

				<p>
					<button
						className="w3-button w3-border w3-border-white"
						onClick={exportToClipboard}
					>
						Export to clipboard
					</button>
				</p>

				<div id={exportToClipboardModalId} className="w3-modal">
					<div className="w3-modal-content w3-dark-grey w3-middle w3-animate-zoom w3-card-4">
						<div className="w3-container w3-padding w3-center">
							<p className="w3-left-align">
								Tags have been successfully copied to clipboard.
							</p>
							<button
								className="w3-button w3-border w3-border-white"
								onClick={() =>
									setModalVisibility(
										exportToClipboardModalId,
										false
									)
								}
							>
								OK
							</button>
						</div>
					</div>
				</div>

				<p>
					<button
						className="w3-button w3-border w3-border-white w3-red"
						onClick={resetConfigConfirmation}
					>
						Reset configuration
					</button>
				</p>

				<div id={resetConfigConfirmModalId} className="w3-modal">
					<div className="w3-modal-content w3-dark-grey w3-middle w3-animate-zoom w3-card-4">
						<div className="w3-container w3-padding w3-center">
							<p className="w3-left-align">
								This will remove all your saved configuration.
								Are you sure?
							</p>
							<button
								className="w3-button w3-border w3-border-white w3-margin"
								onClick={resetConfig}
							>
								I'm sure, continue
							</button>
							<button
								className="w3-button w3-border w3-border-white w3-margin"
								onClick={() =>
									setModalVisibility(
										resetConfigConfirmModalId,
										false
									)
								}
							>
								Cancel
							</button>
						</div>
					</div>
				</div>

				<div id={resetConfigModalId} className="w3-modal">
					<div className="w3-modal-content w3-dark-grey w3-middle w3-animate-zoom w3-card-4">
						<div className="w3-container w3-padding w3-center">
							<p className="w3-left-align">
								Your configuration has been reset. You will be
								directed to the Welcome page.
							</p>
							<a
								href="/"
								className="w3-button w3-border w3-border-white"
							>
								OK
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfigActionsPage;
